import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IUserSlice } from "@/redux/slices/user/types";

export const getCartToken = createAsyncThunk(
  "user/getCartToken",
  async () =>
    await axios
      .get("/shopping-cart/token")
      .catch((err) => err)
      .then((r) => r.data?.token)
);

const fulfilled = (state: IUserSlice, { payload }) => {
  state.cart.token = payload;
};

export default {
  action: getCartToken,
  fulfilled,
};
